import { keyframes } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Root = styled.div({
  position: 'relative',
  overflowX: 'hidden',
  textAlign: 'left',
  font: token('font.body'),
});

export const animateLeft = keyframes({
  from: {
    left: '100%',
  },
  to: {
    left: 0,
  },
});

export const animateRight = keyframes({
  from: {
    left: 0,
  },
  to: {
    left: '100%',
  },
});

export const NotificationDotParent = styled.div({
  position: 'relative',
});

export const NotificationDot = styled.span<{ parentColor: string }>(props => ({
  display: 'block',
  width: '8px',
  height: '8px',
  backgroundColor: token('color.background.discovery', colors.P100),
  position: 'absolute',
  top: '-2px',
  right: '-2px',
  borderRadius: '8px',
  border: `3px solid ${props.parentColor}`,
}));

/* remove this disable once https://github.com/YozhikM/stylelint-a11y/issues/38 is addressed */
/* stylelint-disable a11y/media-prefers-reduced-motion */
export const OverlayPanel = styled.div<{ isShown: boolean }>`
  position: absolute;
  top: 0;
  left: ${props => (props.isShown ? '0' : '100%')};
  height: 100%;
  width: 100%;
  background: ${token('elevation.surface', 'white')};
  animation: ${props => (props.isShown ? animateLeft : animateRight)} 0.15s
    ease-out;
  display: flex;
  flex-direction: column;

  @media screen and (prefers-reduced-motion: reduce) {
    /* https://css-tricks.com/revisiting-prefers-reduced-motion-the-reduced-motion-media-query/ */
    animation-duration: 0.001ms;
    animation-iteration-count: 1;
  }
`;
/* stylelint-enable */

export const OverlayHeader = styled.div({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  position: 'sticky',
  top: 0,
  background: token('elevation.surface', 'white'),
  borderBottom: `1px solid ${token('color.border', colors.N30A)}`,
  padding: '6px',
  textTransform: 'uppercase',
  font: token('font.body.UNSAFE_small'),
  color: token('color.text.subtlest', colors.N200),
  flex: '0 0 auto',
});

export const PostsWrapper = styled.div({
  overflowY: 'auto',
  flex: '1 1 auto',
});
